"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSecondsTpl = void 0;
const plural_ru_1 = __importDefault(require("plural-ru"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const i18n = (0, pythia_libs_1.i18n)(['plural']);
function getSecondsText(count, form) {
    const seconds = i18n(['seconds', form]);
    count = Math.ceil(count);
    return `${count} ${(0, plural_ru_1.default)(count, ...seconds)}`;
}
/*
 можно передать падеж
 form: 'im' | 'ro'
*/
function buildSecondsTpl(tpl, seconds, form = 'im') {
    return tpl.replace('%1', getSecondsText(seconds, form));
}
exports.buildSecondsTpl = buildSecondsTpl;
